import React from 'react';
import { Alert, Col, Form, Row } from 'react-bootstrap';
import { ActionButtons, Loader } from '../../../common/components';
import { LOADING_STATUS } from '../../../common/constants';

function RateMinimumLengthOfStayForm({
  loadingStatus,
  handleInputChange,
  onSubmit,
  onDelete,
  submitted,
  deleted,
  data,
  hasWriteAccess,
  isDefaultRate = false,
}: {
  loadingStatus: LOADING_STATUS;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  onSubmit: any;
  onDelete?: any;
  submitted: boolean;
  deleted?: boolean;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  data: any;
  hasWriteAccess: boolean;
  isDefaultRate?: boolean;
}) {
  return (
    <>
      <Loader IsLoading={loadingStatus === LOADING_STATUS.LOADING} />
      {loadingStatus === LOADING_STATUS.IDLE && (
        <>
          <Form.Group controlId="minimumLengthOfStay" className="mb-24">
            <Form.Label>Minimikesto vuorokausina</Form.Label>
            <Form.Control
              type="text"
              name="minimumLengthOfStay"
              onChange={handleInputChange}
              value={data.minimumLengthOfStay || ''}
              placeholder="Anna vuorokausien lukumäärä"
              readOnly={!hasWriteAccess}
            />
            <Form.Text muted>
              Estää lyhyemmät varaukset kuin annettu vuorokausien määrä
            </Form.Text>
          </Form.Group>

          {isDefaultRate ? (
            <>
              <input type="hidden" name="isActive" value="true" />
              <input type="hidden" name="isCopyable" value="true" />
            </>
          ) : (
            <Row xs="auto">
              <Col>
                <Form.Group controlId="isActive" className="mb-24">
                  <Form.Label>Aktiivinen sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isActive"
                    onChange={handleInputChange}
                    checked={data.isActive}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="isCopyable" className="mb-24">
                  <Form.Label>Kopioitava sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isCopyable"
                    onChange={handleInputChange}
                    checked={data.isCopyable}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <ActionButtons
            HandleSave={onSubmit}
            HideSaveButton={!hasWriteAccess}
            HideCancelButton
            DeleteButtonText="Poista"
            HandleDelete={onDelete}
          />
          {submitted && (
            <div className="mt-2 pt-2">
              <Alert variant="success">Tiedot tallennettu!</Alert>
            </div>
          )}
          {deleted && (
            <div className="mt-2 pt-2">
              <Alert variant="danger">Sääntö poistettu!</Alert>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default RateMinimumLengthOfStayForm;
